var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackageHtlIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "33.751px",
    viewBox: "0 5.625 45 33.751",
    enableBackground: "new 0 5.625 45 33.751",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#373E43",
    d: "M44.063,24.375H7.5V6.563c0-0.518-0.419-0.938-0.938-0.938H0.938C0.419,5.625,0,6.044,0,6.563v31.875 c0,0.519,0.419,0.938,0.938,0.938h5.625c0.518,0,0.938-0.42,0.938-0.938v-6.563h30v6.563c0,0.519,0.42,0.938,0.938,0.938h5.625 c0.518,0,0.938-0.42,0.938-0.938V25.313C45,24.795,44.58,24.375,44.063,24.375z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#373E43",
    cx: 15,
    cy: 16.875,
    r: 5.625
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#373E43",
    d: "M23.438,22.5h20.625C44.58,22.5,45,22.081,45,21.563c0-5.687-4.626-10.313-10.313-10.313h-11.25 c-0.519,0-0.938,0.419-0.938,0.938v9.375C22.5,22.081,22.919,22.5,23.438,22.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageHtlIco);
export default __webpack_public_path__ + "static/media/package_htlIco.9a12fac987a4a03df9acd45b0fc6a984.svg";
export { ForwardRef as ReactComponent };